import { createStore } from 'vuex';

// RootState
export interface IRootState {
    version: string;
}
export const RootState: IRootState = {
    version: '0.0.1'
};

import general, { NAME as GENERAL } from '@/store/modules/general';
import resource, { NAME as RESOURCE } from '@/store/modules/resource';
import validation, { NAME as VALIDATION } from '@/store/modules/validation';
import security, { NAME as SECURITY } from '@/store/modules/security';
import headerNotification, { NAME as HEADERNOTIFICATION } from '@/store/modules/headerNotification';
import loadingSpinner, { NAME as LOADINGSPINNER } from '@/store/modules/loadingSpinner';
import modalConfirmation, { NAME as MODALCONFIRMATION } from '@/store/modules/modalConfirmation';
// AREAS
import home, { NAME as HOME } from '@/areas/kunde/home/store/index';
import einstellungen, { NAME as EINSTELLUNGEN } from '@/areas/kunde/profileinstellungen/store';
import registration, { NAME as REGISTRATION } from '@/areas/kunde/registrierung/store';
import archiv, { NAME as ARCHIV } from '@/areas/kunde/archiv/store';
import rechnungen, { NAME as RECHNUNGEN } from '@/areas/kunde/lieferantenrechnung/store';
import praxisgruppeRechnungen, { NAME as PRAXISGRUPPE_RECHUNGEN } from '@/areas/praxisgruppe/store';
import praxisgruppeAdministration, { NAME as PRAXISGRUPPEADMINISTRATION } from '@/areas/praxisgruppeadministration/store';
import treuhandAdministration, { NAME as TREUHANDADMINISTRATION } from '@/areas/treuhandadministration/store';
import lieferantAdministration, { NAME as LIEFERANTADMINISTRATION } from '@/areas/lieferantadministration/store';

import lieferantRechnungen, { NAME as LIEFERANTRECHNUNGEN } from '@/areas/lieferant/store';

import treuhand, { NAME as TREUHAND } from '@/areas/treuhand/store';

import upload, { NAME as UPLOAD } from '@/areas/kunde/upload/store';
import administration, { NAME as ADMINISTRATION } from '@/areas/administration/store';

export const store = createStore({
    state: RootState,
    mutations: {},
    actions: {},
    modules: {
        [GENERAL]: general,
        [RESOURCE]: resource,
        [VALIDATION]: validation,
        [SECURITY]: security,
        [HEADERNOTIFICATION]: headerNotification,
        [LOADINGSPINNER]: loadingSpinner,
        [MODALCONFIRMATION]: modalConfirmation,
        // AREAS
        [HOME]: home,
        [EINSTELLUNGEN]: einstellungen,
        [REGISTRATION]: registration,
        [ARCHIV]: archiv,
        [RECHNUNGEN]: rechnungen,
        [PRAXISGRUPPE_RECHUNGEN]: praxisgruppeRechnungen,
        [PRAXISGRUPPEADMINISTRATION]: praxisgruppeAdministration,
        [TREUHAND]: treuhand,
        [TREUHANDADMINISTRATION]: treuhandAdministration,
        [LIEFERANTRECHNUNGEN]: lieferantRechnungen,
        [LIEFERANTADMINISTRATION]: lieferantAdministration,
        [UPLOAD]: upload,
        [ADMINISTRATION]: administration
    }
});

export default store;
